<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
    <notifications classes="my-notifi" width="400" :duration="2000" position="right top" />
  </div>
</template>

<script>
export default {
  computed: {
    layout () {
      return this.$route.meta.layout || 'default'
    }
  },
}
</script>
